// 管理模块页
const adminComponents = [
    'Administrator', 'AdminLoginRecord', 'AdminMenuList', 'AdminOperationRecord', 'AdminStyle',
    'AdminWxNotificationLog', 'AllocationList', 'BusinessGroup', 'BusinessMonthTarget', 'BusinessWorkTime', 'CategoryMemorandumList',
    'LoginRecordList', 'moduleList', 'NoticeList', 'permissionsList', 'RoleDeauthorizationRecord', 'RoleList', 'RolePermissionSet',
    'SmsRecord', 'StudentLoginList', 'StudentWxNotificationLog', 'SystemConfigModification', 'SystemLog', 'SystemMessage', 'TeacherWxNumber',
    'FocusFigure', 'HomePanelMenu', 'PcIndexMenu', 'ArticlePromotionSettings', 'WxPublicMenu', 'WxTemplateMessage', 'AdvertisingImages',
    'CompanyEntity', 'Blacklist', 'TimingTask', 'TimingTaskLog', 'ConfigServer', 'SmallProgramBackground', 'ProjectDocuments', 'AllClient',
    'CampusSetting','TrialListenSettings','RotatingImageSettings','ExamPreparationExchangeGroup','VisitRecord','AiCategory','AiSetup','AiRecord',"AllocationValueRecord"
]
// 学员模块页
const studentComponents = [
    'StudentListNew', 'BusinessWillOceanStudent', 'BusinessOceanStudent', 'DropIntoOceanRecordList',
    'BusinessOceanHandle', 'BusinessToDistribute', 'BusinessDistributeStudentRecords',
    'BusinessToReceiveStudent', 'BusinessReceiveStudentRecords', 'EducationalStudentsHandover', 'StudentDataDown',
    'ImportStudentDataNew', 'TrackingStatistics', 'AddressBook', 'WeChatChatHistory', 'StudentRegistration',
    'IntentChangeRecord', 'ChatHistoryList', 'SellKeywords', 'AgreementList', 'AgreementRecordList',
    'UnSignAgreement', 'GenerateProtocol', 'StudentDynamicList', 'StudentSortDivide', 'StudentSortModule',
    'Classification', 'MaterialSetting', 'TemplateLabel', 'StudentDateTypeList', 'TagSetting', 'RoleChannelConfiguration',
    'StudentPublicAttention', 'SbAmbassadors', 'Promoteshare', 'SpreadToStudentList', 'RegisteredStudents','RecommendExamList',
    'CompetitivenessSchoolStudents','IntelligentAanalysis','StudentCallRecord','QualityInspection','SalesArchiving','SalesMission','SalesAnalysisList','EnterpriseWeChatChatHistory','AmbassadorAllocationList','WechatWorkContactList'

]
// 产品模块页
const productComponents = [
    'ProductCategory', 'ProductServiceList', 'NewCourseList', 'CourseChangeRecord',
    'KnowledgClass', 'SubjectList', 'ExamTestPaperList', 'ExerciseList', 'ArticleClass', 'ArticleList',
    'PageCourse', 'PageExamExercise', 'CourseRecordList', 'CourseStudentLearns', 'TeachLiveRecord',
    'LiveRecording', 'ExercisesAnswerRecord', 'ExaminationStudent', 'OnlineExaminationStudent','ClassExamRecords',"ExamReport","StatsOverview","StudentDashboard"
]
// 订单模块页
const orderComponents = [
    'ShoppingCartList', 'OrderList', 'AliPayconfig', 'InstallmentOrder', 'OrderChangeRecordList', 'PayRecordList',
    'PerformanceRecord', 'StudentOutstandingList', 'WeChatPayconfig', 'CommissionSetting', 'GroupSetUp', 'Groupon', 'GrouponRecord', 'Coupon', 'CouponGet',
    'IntegralTask', 'IntegralTaskRecord', 'StudentOrder','integralStatistics'
]
// 报表模块页
const reportComponents = [
    "AssignAccessReport", "AllocationWeightStatistics", "CourseConversion", "CourseRegistrationPerformanceReport",
    "EarningReport", "EstimateScore", "GetTraceSourceReport", "GraduatedMajorReport", "GraduatedSchoolReport", "InformationImprovementReport", "OpenSeaWarehouseRepor",
    "RegistrationForm", "RegistrationPerformanceReport", "SalesFunnelReport", "EnrollmentMessage","romotionalPopupConfig", "EstimateScoreManage","PeriodicReports",
    "TopAcademicAchievers","TopStudentsReport"
]
// 教学模块页
const teachComponents = ['BatchImportExams', 'CreateSurvey', 'DailyScheduleList', 'EducationalClassGroup', 'EducationalClassIntegralRecord', 'ExamAndHomeworkCreate',
    'GradeCategoryList', 'GradeList', 'QuestionnaireReview', 'RoomList', 'TeacherList', 'TeachingLiveRoom', 'TodayMessage', 'QuestionSurveySetting', 'CourseClassStatistics',
    'StudentClassAllocation', 'GradeDistributionRecord', 'LectureRoomCapacity', 'OnlineSchedule', 'TeachingBookDistribution', 'MailingBookRecord', 'TextbookList',
    'AddressList', 'HarvestAddress', 'StudentQuestionCategory', 'QuestionList', 'StudentQuestionList', 'Suggest', 'StudentSignInRecordList', 'StudentLeaveRecordList',
    'StudentAbsenteeismRecordList', 'AdminWorkCategory', 'JobManagement', 'JobMessageManagement', 'JobRecords','PromotionalPopupConfig','IntelligentExamCreate',
    "EducationalClassConfig", "EducationalClassGroupNew","StudentPointsRanking","ClassTeachReport","ClassStudentList",'PersonalExaminationPoints','ExamPointRanking',
    "DailyScheduleStatistics","StudentAbnormalList",'WrongQuestionStats','RecruitTeacherStudentReport'
]
  
// 单词模块页
const wordComponents = [
    'WordSettings', 'WordBook', 'WordBookCategory', 'UnlockRecord', 'PracticeRecord', 'LearnRecord', 'CollectHistory', 'WordTagSet',
    'WordsDifficultyLevel', 'WordNotePage', 'PkRoom', 'PkModel', 'MiniProgramSharingSet', 'WordFeedback','WordUserManagement','WordPracticeSchedule',
    'WordPracticeRecord','MistakeNotebook','WordTreasureOperationReport','WeeklyReportList','WordMnemonicList','WordMnemonicInteractionList'
]
// 开票模块页
const invoicingComponents = [
    'InvoiceCompany','InvoiceResult', 'InvoicingApplicationRecord'
]
// 营销模块页
const marketingComponents = [
    'ActivitySettings','InvitationList','UserPointsAcquisition','LotteryRecord','UserGiftCollectionRecord','ActivityBlacklist','AddEditActivitySettings',
    'DistributionManagement','DistributionCommissionBreakdown','DistributionWithdrawalApplication','DistributionSharingRecord','AppletShortChain'
]
export {
    adminComponents,
    studentComponents,
    productComponents,
    orderComponents,
    reportComponents,
    teachComponents,
    wordComponents,
    invoicingComponents,
    marketingComponents
}